import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
    getQuestionOptions, 
    addQuestionOptions as postQuestionOptions, 
    updateQuestionOptions as putQuestionOptions, 
    deleteQuestionOptions as removeQuestionOptions
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";


// Fetch Table Column Names
export const fetchQuestionOptionsTableColumnNames = createAsyncThunk("questionOptions/fetchTableColumnNames", async (questionOptions, thunkAPI) => {
    try {
      const response = await getHeaders(questionOptions); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Courses
export const fetchAllQuestionOptions = createAsyncThunk("questionOptions/fetchAll", async (thunkAPI) => {
    try {
      const response = await getQuestionOptions(); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Course
export const createQuestionOptions = createAsyncThunk("questionOptions/add", async (questionOptions, thunkAPI) => {  
    try {
        const response = await postQuestionOptions(questionOptions);
        toast.success(response.message);
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Course
export const updateQuestionOptions = createAsyncThunk("questionOptions/update", async (questionOptions, thunkAPI) => {
    try {
        const response = await putQuestionOptions(questionOptions);
        toast.success(response.message);
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Course
export const deleteQuestionOptions = createAsyncThunk("questionOptions/delete", async (questionOptions, thunkAPI) => {
    try {
        const response = await removeQuestionOptions(questionOptions);
        toast.success(response.message);
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});